<template>
  <div class="login-page e-view ej2-new">
    <div class="signin-box">
      <LoginForm></LoginForm>
    </div>
    <div class="signin-bottom1"></div>
    <div class="signin-bottom2">
      <div class="signin-copyright">
        {{$t('Login.footer.standby')}}<br>
        {{$t('Login.footer.copyright')}}
      </div>
    </div>
  </div>
</template>

<script>
import LoginForm from '../components/frame/LoginForm';

export default {
  name: 'LoginLayout',
  components: {
    LoginForm
  }
};
</script>
